import { ItemCard } from "./ItemCard";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import type { Item } from "@outplayed/riot-assets";

interface ItemBuildsIntoProps {
  itemId: number;
  itemData: Item;
}

export function ItemBuildsInto(props: ItemBuildsIntoProps) {
  const { useItemsWiki } = getRiotAssetsContext();
  const itemsList = useItemsWiki({ ssr: true });
  const itemsJSON = itemsList.data;
  const availableItems = itemsJSON?.availableItems;
  const { itemData, itemId } = props;
  if (!itemData || !itemId) return null;

  const itemCardProps = {
    showGold: false,
    itemClass: "items-pic-30 items-border-normal-small",
    textClass: "text-small",
  };

  const itemsBuildsInto = itemData?.into?.filter((id) => availableItems.includes(parseInt(id)));

  return (
    <div className="items-section items-builds-into">
      <HeaderBullet className="mb-[24px]">Builds Into</HeaderBullet>
      <div className="builds-into-container">
        {itemsBuildsInto?.map((id) => (
          <ItemCard key={id} itemId={parseInt(id)} {...itemCardProps} />
        ))}
      </div>
    </div>
  );
}
